import deleteListingSaga from './deleteListingSaga';
import updateListingStateSaga from './updateListingStateSaga';

export default [deleteListingSaga(), updateListingStateSaga()];
